import { createAction } from '@reduxjs/toolkit';
import {
    typeEpsTableDataItem,
    typeMerchantPaymentSystem,
    typePosSettingsEpsItem
} from 'model/dashboardEPS/dEpsReducer';

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set table data
export const dEpsSetDataAC = createAction(
    'D_EPS_SET_DATA',
    (
        dataList: typeEpsTableDataItem[],
    ) => ({payload: {dataList}})
)

// Action creator of saga set data
export const dEpsSetDataSagaAC = createAction(
    'D_EPS_SET_DATA_SAGA'
)

// ---------------------------------------------------------------------------------------------------------------------
export const dEpsSetEpsListAC = createAction(
    'D_EPS_SET_EPS_LIST',
    (
        dataList: typeMerchantPaymentSystem[],
    ) => ({payload: {dataList}})
)
// ---------------------------------------------------------------------------------------------------------------------
export const dEpsSetPosSettingsListAC = createAction(
    'D_EPS_SET_POS_SETTINGS_LIST',
    (
        dataList: typePosSettingsEpsItem[],
    ) => ({payload: {dataList}})
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dEpsCheckedTerminalsItemAC = createAction(
    'D_EPS_CHECK_TERMINALS_ITEM',
    (itemId: string) => ( { payload: itemId } )
)

// Action creator of checked all items
export const dEpsCheckedAllTerminalsItemAC = createAction(
    'D_EPS_CHECK_ALL_TERMINALS_ITEM',
    (value: boolean) => ( { payload: value } )
)

// ---------------------------------------------------------------------------------------------------------------------
export const dEpsClearStateAC= createAction(
    'D_EPS_CLEAR_STATE'
)
// ---------------------------------------------------------------------------------------------------------------------

// Action creator of set selected terminal
export const dEpsSetDetailsTerminalsItemAC = createAction(
    'D_EPS_SET_DETAILS_TERMINALS_ITEM',
    (item: typeEpsTableDataItem | null) => ( { payload: item } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set selected eps
export const dEpsSetDetailsEPSItemAC = createAction(
    'D_EPS_SET_DETAILS_EPS_ITEM',
    (item: typeMerchantPaymentSystem | null) => ( { payload: item } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of create new ps object
export const dEpsCreateNewPSObjectItemSagaAC = createAction(
    'D_EPS_CREATE_NEW_PS_OBJECT_ITEM_SAGA',
    (paymentSystemId: string, externalId: string) => ( { payload: {paymentSystemId, externalId}} )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of create connection between terminal && psObject
export const dEpsAddPosSettingsForTerminalsSagaAC = createAction(
    'D_EPS_ADD_POS_SETTINGS_FOR_TERMINALS_SAGA',
    (terminalIds: string[], psObjectId: string) => ( { payload: {terminalIds, psObjectId}} )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of disconnect terminal item from eps'
export const dEpsDisconnectTerminalItemFromEpsSagaAC = createAction(
    'D_EPS_DISCONNECT_TERMINAL_ITEM_FROM_EPS_SAGA',
    (terminalId: string, epsIds: string[], terminalPosSettings: typePosSettingsEpsItem) => ( { payload: {terminalId, epsIds, terminalPosSettings}} )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk  disconnect terminals item from eps'
export const dEpsBulkDisconnectTerminalsFromEpsSagaAC = createAction(
    'D_EPS_BULK_DISCONNECT_TERMINALS_FROM_EPS_SAGA',
    (terminalIds: string[], epsIds: string[], posSettings: typePosSettingsEpsItem[]) => ( { payload: {terminalIds, epsIds, posSettings}} )
)
